import { Result } from 'antd';
import type { FC} from 'react';
import React, { useEffect, useState } from 'react';

/** 结果页面 */
const ResultExam: FC = () => {
  const [status, setStatus] = useState<string>('');
  useEffect(() => {
    const query = new URLSearchParams(window.location.search);
    window.Pandora.send('zijin_testee_page_view', {
      page: 'end',
      status: query.get('status'),
      onlyid: query.get('exam_id'),
    });
    setStatus(query.get('status')!);
  }, []);

  /** 此代码用来解决卷子提交后，关闭页面时对话框的问题 */
  if(status==='0' || status==='1' || status==='2' || status==='3' || status==='autosubmit') {
    window.onbeforeunload = () => { return null; };
  }

  if (status === '0') {
    return <Result status="success" title="笔试结束，请关闭页面，等待HR后续通知" />;
  }
  if (status === '2') {
    return <Result status="warning" title="笔试已超时，题目已自动提交，请关闭页面，等待HR后续通知" />;
  }
  if (status === '3') {
    return <Result status="warning" title="考试结束后无法查看试卷，请关闭页面，等待HR后续通知" />;
  }
  if (status === 'autosubmit') {
    return <Result status="warning" title="笔试时间到，答案系统将自动提交，请关闭页面，等待HR后续通知" />;
  }
  if (status === '1') {
    return <Result status="warning" title="系统异常可能提交失效，请联系 HR" />;
  }
  return <Result status="info" title="重定向出错,提交可能失败，请联系 HR" />;
};

export default ResultExam;
